import { render, staticRenderFns } from "./BcAddressDialog.vue?vue&type=template&id=71d1187b"
import script from "./BcAddressDialog.vue?vue&type=script&lang=js"
export * from "./BcAddressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports